export const ACCENT = '#D92D20';

export const TRAINING_CATEGORY = { TECHNICAL: 'technical', PROCESS: 'process', PRODUCT: 'product', OTHER: 'other' };

export const CATEGORY_STYLES = {
    [TRAINING_CATEGORY.TECHNICAL]: { dot: '#2563EB', background: '#EFF4FF', color: '#1E40AF' },
    [TRAINING_CATEGORY.PROCESS]: { dot: '#16A34A', background: '#ECFDF3', color: '#067647' },
    [TRAINING_CATEGORY.PRODUCT]: { dot: '#F97316', background: '#FFF4ED', color: '#B93815' },
    [TRAINING_CATEGORY.OTHER]: { dot: '#7C3AED', background: '#F4F3FF', color: '#5925DC' }
};

export const CATEGORY_ORDER = [TRAINING_CATEGORY.TECHNICAL, TRAINING_CATEGORY.PROCESS, TRAINING_CATEGORY.PRODUCT, TRAINING_CATEGORY.OTHER];

// TRAINING_TYPES lookup kodu -> takvim rengi; eşleşmeyen kod "Other".
export const getTrainingCategory = (trainingType) => {
    const code = String(trainingType || '').toUpperCase();
    if (code.includes('TECH')) return TRAINING_CATEGORY.TECHNICAL;
    if (code.includes('PROCESS')) return TRAINING_CATEGORY.PROCESS;
    if (code.includes('PRODUCT')) return TRAINING_CATEGORY.PRODUCT;
    return TRAINING_CATEGORY.OTHER;
};

export const formatTime = (value) => (value ? String(value).slice(0, 5) : '');

const parsePlainDate = (value) => {
    if (!value) return null;
    const [y, m, d] = String(value).slice(0, 10).split('-').map(Number);
    return y && m && d ? new Date(y, m - 1, d) : null;
};

const pad = (n) => String(n).padStart(2, '0');

export const formatPlainDate = (value) => {
    const date = parsePlainDate(value);
    return date ? `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}` : '';
};

// "20–23" + "EKİ 2026" şeklinde iki satırlık tarih bloğu
export const getDateBlock = (startDate, endDate, locale) => {
    const start = parsePlainDate(startDate);
    if (!start) return { days: '-', monthYear: '' };
    const end = parsePlainDate(endDate) || start;
    const month = (date) => date.toLocaleDateString(locale, { month: 'short' }).replace('.', '').toLocaleUpperCase(locale);
    const sameDay = start.getTime() === end.getTime();
    const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();

    if (sameDay) return { days: String(start.getDate()), monthYear: `${month(start)} ${start.getFullYear()}` };
    if (sameMonth) return { days: `${start.getDate()}–${end.getDate()}`, monthYear: `${month(start)} ${start.getFullYear()}` };
    return { days: `${start.getDate()} ${month(start)} – ${end.getDate()} ${month(end)}`, monthYear: String(end.getFullYear()) };
};

export const formatDateTimeRange = (item) => {
    const start = [formatPlainDate(item?.startDate), formatTime(item?.startTime)].filter(Boolean).join(' ');
    const end = [formatPlainDate(item?.endDate), formatTime(item?.endTime)].filter(Boolean).join(' ');
    return end && end !== start ? `${start} – ${end}` : start;
};

export const formatFee = (fee, currency, locale) => {
    if (fee === null || fee === undefined || fee === '') return '-';
    const amount = Number(fee);
    if (!Number.isFinite(amount)) return [fee, currency].filter(Boolean).join(' ');
    if (currency) {
        try {
            return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 }).format(amount);
        } catch {
            // geçersiz ISO kodu
        }
    }
    return [amount.toLocaleString(locale, { maximumFractionDigits: 2 }), currency].filter(Boolean).join(' ');
};

export const formatNumber = (value, locale) => (value === null || value === undefined ? '-' : Number(value).toLocaleString(locale));
